import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminMemberDetails, { memberDate, memberRole } from '../components/AdminMemberDetails';
import { planLabel } from '../lib/plans';
import '../styles/adminResponsive.css';

const LIMIT = 25;
export default function AdminMembers() {
  const [q, setQ] = useState('');
  const [role, setRole] = useState('');
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState(null);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let current = true;
    setLoading(true); setError(''); setSelected(null);
    const timer = setTimeout(() => {
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/users`, { params: { q, role, offset, limit: LIMIT }, timeout: 12000 })
        .then(({ data: next }) => {
          if (!current) return;
          if (!next.items.length && offset > 0) { setOffset(Math.max(0, offset - LIMIT)); return; }
          setData(next);
        }).catch(() => { if (current) setError('Üyeler yüklenemedi. Yeniden deneyin.'); })
        .finally(() => { if (current) setLoading(false); });
    }, 250);
    return () => { current = false; clearTimeout(timer); };
  }, [q, role, offset, revision]);
  return <section className="p-8 max-w-7xl mx-auto admin-directory-page" data-testid="admin-members-page">
    <div className="mb-6"><h1 className="text-3xl font-semibold">Üyeler</h1>
      <p className="mt-2">Kayıtlı hesaplar ve giriş bilgileri. Profilini henüz oluşturmayan üyeler de burada görünür.</p></div>
    <div className="admin-member-filters">
      <label>Ad veya e-posta<input className="admin-member-input" type="search" value={q} placeholder="Üye ara" maxLength={120}
        onChange={e => { setQ(e.target.value); setOffset(0); }} /></label>
      <label>Hesap türü<select className="admin-member-input" value={role} onChange={e => { setRole(e.target.value); setOffset(0); }}>
        <option value="">Tüm üyeler</option><option value="venue">Mekân</option><option value="organizer">Organizatör</option><option value="admin">Yönetici</option><option value="pool_manager">Personel</option>
      </select></label>
    </div>
    {loading ? <p role="status">Üyeler yükleniyor…</p> : error ? <div role="alert"><p>{error}</p><button className="admin-member-button" onClick={() => setRevision(r => r + 1)}>Tekrar dene</button></div> : <>
      <p className="mb-4">{data.total} üye</p>
      {!data.items.length && <p>Bu aramaya uygun üye bulunamadı.</p>}
      <div className="admin-members-list">
        {data.items.map(member => <article key={member.id} className="admin-member-card">
          <div className="admin-member-summary">
            <div><h2 className="font-semibold">{member.name || 'İsimsiz hesap'}</h2><p className="admin-member-email">{member.email}</p></div>
            <div>{memberRole(member.role)} · {planLabel(member.plan)}{member.staff_role ? ' · Havuz Yöneticisi' : ''}<p className="text-sm">{memberDate(member.created_at)}</p></div>
            <button className="admin-member-button" type="button" aria-expanded={selected === member.id}
              onClick={() => setSelected(selected === member.id ? null : member.id)}>{selected === member.id ? 'Detayı kapat' : 'Hesap detayı'}</button>
          </div>
          {selected === member.id && <AdminMemberDetails userId={member.id} onDeleted={() => { setSelected(null); setRevision(r => r + 1); }} />}
        </article>)}
      </div>
      <nav className="admin-member-actions mt-6" aria-label="Üye listesi sayfaları">
        <button className="admin-member-button" disabled={offset === 0} onClick={() => setOffset(Math.max(0, offset - LIMIT))}>Önceki</button>
        <span>{data.total ? offset + 1 : 0}–{Math.min(offset + LIMIT, data.total)} / {data.total}</span>
        <button className="admin-member-button" disabled={offset + LIMIT >= data.total} onClick={() => setOffset(offset + LIMIT)}>Sonraki</button>
      </nav>
    </>}
  </section>;
}
